import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UploadState {
  allMasterDataOptions: any
  save_case_id: any // <-- new
  perverse_value: any
}

// --- Safely parse from localStorage ---
let parsedData: any = null
const localStorageData = localStorage.getItem('allMasterDataOptions')

if (localStorageData) {
  try {
    parsedData = JSON.parse(localStorageData)
  } catch (e) {
    console.warn('Invalid JSON found in localStorage. Clearing key.', e)
    localStorage.removeItem('allMasterDataOptions')
  }
}

const initialState: UploadState = {
  allMasterDataOptions: parsedData,
  save_case_id: sessionStorage.getItem('save_case_id') || null,
  perverse_value: null,
}

const MasterDataSlice = createSlice({
  name: 'allMasterDataOptions',
  initialState,
  reducers: {
    MasterDataStore(state, action: PayloadAction<any>) {
      if (action.payload !== undefined && action.payload !== null) {
        state.allMasterDataOptions = action.payload
        localStorage.setItem('allMasterDataOptions', JSON.stringify(action.payload))
      } else {
        // if payload is undefined or null, clear storage
        state.allMasterDataOptions = null
        localStorage.removeItem('allMasterDataOptions')
      }
    },
    setSaveCaseId(state, action: PayloadAction<any>) {
      if (action.payload !== undefined && action.payload !== null) {
        state.save_case_id = action.payload
        sessionStorage.setItem('save_case_id', action.payload)
      } else {
        state.save_case_id = null
        sessionStorage.removeItem('save_case_id')
      }
    },
    PerverseValue(state, action: PayloadAction<any>) {
      if (action.payload !== undefined && action.payload !== null) {
        state.perverse_value = action.payload
      } else {
        state.perverse_value = null
      }
    },
  },
})

export const { MasterDataStore, setSaveCaseId, PerverseValue } = MasterDataSlice.actions
export default MasterDataSlice.reducer
